export const filterUserTable = (users: any[], userSelected: any): any[] => {
    const filterName = userSelected?.name ?? '';

    const filteredData = users.filter((user: any) => {
      const matchName = !filterName || user.email === filterName;
      return matchName;
    });
    return filteredData;
}